import {DataFetcher} from '@aboutyou/data-fetcher';
import {GetSearchResultsPageBulkResponse} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/search/v1/service.types';
import {useCanGoBack, useHistory, useSearchRoute} from '@aboutyou/router';
import {CategoryHeader} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {FiltersHeaderLoading} from '../../../features/Filters/FiltersHeader/FiltersHeaderLoading';
import {useCategoryIdentifier} from '../hooks/useCategoryIdentifier';
import {useSearchNavigationHeaderSection} from '../hooks/useSearchPageBulkSection';
import {useSearchTerm} from '../hooks/useSearchTerm';

export const SearchStreamHeaderCompact: React.FC<{
  renderingPriority?: number;
}> = ({renderingPriority, ...viewProps}) => {
  return (
    <DataFetcher
      request={useSearchNavigationHeaderSection()}
      Error={null}
      Loading={FiltersHeaderLoading}
      View={FiltersHeaderView}
      viewProps={viewProps}
      renderingPriority={renderingPriority}
    />
  );
};

const FiltersHeaderView: React.FC<
  GetSearchResultsPageBulkResponse['navigationHeader']
> = props => {
  const term = useSearchTerm();
  const adjustedTerm = term.length > 20 ? `${term.slice(0, 20)}…` : term;
  const searchRoute = useSearchRoute();
  const history = useHistory();
  const categoryIdentifier = useCategoryIdentifier();

  const canGoBack = useCanGoBack();

  const onBack = () => {
    if (canGoBack && !categoryIdentifier) {
      // Go back twice to skip the search mask page and return to the previous page
      history.goBack();
      history.goBack();
    } else if (canGoBack) {
      history.goBack();
    } else {
      history.push(searchRoute);
    }
  };

  return (
    <StyledCategoryHeader
      centered
      onBack={onBack}
      sidePadding
      stickyOnScrollUp={false}
      categoryName={`“${adjustedTerm}”`}
      subtitle={props.category.name}
    />
  );
};

const StyledCategoryHeader = styled(CategoryHeader)`
  text-align: center;
`;
